//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import RouteView from '@/components/layouts/RouteView';
import { mixinDevice } from '@/utils/mixin.js';
export default {
  name: 'UserLayout',
  components: {
    RouteView: RouteView
  },
  mixins: [mixinDevice],
  data: function data() {
    return {
      copyright: ''
    };
  },
  mounted: function mounted() {
    document.body.classList.add('userLayout');
    this.copyright = window.localStorage.getItem('copyright') && window.localStorage.getItem('copyright') != 'null' ? window.localStorage.getItem('copyright') : '';
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove('userLayout');
  }
};